import type { Components } from '@mui/material/styles';

export default function MuiDialogContentText(): Components['MuiDialogContentText'] {
  return {};
}
